import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ae6fc52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rent-plan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AntdSpin = _resolveComponent("AntdSpin")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AntdSpin, { spinning: _ctx.operate }, null, 8, ["spinning"]),
    _createVNode(_component_a_table, {
      dataSource: _ctx.data,
      columns: _ctx.columns,
      bordered: "",
      pagination: false,
      scroll: { x: _ctx.width - 10, y: _ctx.height }
    }, null, 8, ["dataSource", "columns", "scroll"])
  ]))
}